const initMenu = (element) => {
    const body = document.querySelector('.js-body');
    const menuToggle = element.querySelector('.js-menu-toggle');
    const stopScrollingClass = 'stop-scrolling';
    const isActiveClass = 'menu-active';
    let isActive = false;

    const updateMenuState = () => {
        if (isActive) {
            body.classList.add(stopScrollingClass, isActiveClass);
        } else {
            body.classList.remove(stopScrollingClass, isActiveClass);
        }
    };

    menuToggle.addEventListener('click', (e) => {
        e.preventDefault();
        isActive = !isActive;
        updateMenuState();
    });

    document.addEventListener('click', (e) => {
        if (isActive && !element.contains(e.target)) {
            isActive = false;
            updateMenuState();
        }
    });
};

export { initMenu as default };
